var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"variant":"danger","show":_vm.showErrorMessage}},[_c('span',{domProps:{"innerHTML":_vm._s((_vm.display_message + ": " + _vm.errorMessage))}})])}
var staticRenderFns = []

export { render, staticRenderFns }